export default __webpack_public_path__ + "static/media/Slide5.c853785d.jpg";